import React, { useEffect } from "react";

/**Import Styles and Assets */
import styles from "./index.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { fetchInboxThunk } from "../../features/InboxReducer";

import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from "antd";
const antIcon = <LoadingOutlined style={{ fontSize: 35, color: "white" }} spin />;

export default function Inbox() {

    const dispatch = useDispatch();
    const { data, status } = useSelector(state => state.inbox);

    useEffect(() => {
        if (status !== "success") {
            dispatch(fetchInboxThunk());
        }
    }, [])

    return (
        <div className={styles.inbox}>
            <div className={styles.title}>
                <h1 className={styles.contentTitle}>Inbox</h1>
            </div>
            <div className={styles.content} >
                {status === 'pending' ? <Spin indicator={antIcon} size="large" /> :
                    data.map((item, index) => <div className={styles.notification} key={index}>
                        <p className={styles.body}>{item.body}</p>
                        <span className={styles.date}>{item.created_at}</span>
                    </div>
                    )
                }

            </div>

        </div>
    )
}